var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookingReportCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "8351261_3885912 1",
    clipPath: "url(#clip0_4795_1352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M155 0H0V155H155V0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M40.2982 39.3536C40.2982 39.3536 45.703 38.3185 45.5034 28.1455C45.3037 17.9726 59.0318 17.5786 82.9979 16.8389C106.964 16.0989 123.674 18.3185 129 32.7459C134.326 47.173 127.136 56.5446 111.691 59.2574C96.246 61.9702 105.025 70.2454 113.954 71.4032C126.286 73.0022 131.962 84.7909 125.172 93.4842C118.381 102.178 110.306 103.635 108.317 113.996C105.809 127.051 85.0467 141.306 56.2443 139.092C24.1831 136.627 11.8752 115.905 17.6896 95.0782C20.9269 83.4818 33.8669 78.2465 43.653 75.6571C53.4391 73.0676 48.8458 61.7849 32.0692 64.5594C15.2926 67.3339 12.8892 49.9798 21.9046 45.1577C29.8912 40.8856 33.1083 42.3128 40.2982 39.3536Z",
    fill: "#C5E2F6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M36.3134 36.1091C38.5141 36.1091 40.2981 34.3251 40.2981 32.1244C40.2981 29.9237 38.5141 28.1396 36.3134 28.1396C34.1126 28.1396 32.3286 29.9237 32.3286 32.1244C32.3286 34.3251 34.1126 36.1091 36.3134 36.1091Z",
    fill: "#C5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M41.1511 27.1889C42.5998 27.1889 43.7743 26.0144 43.7743 24.5656C43.7743 23.1169 42.5998 21.9424 41.1511 21.9424C39.7023 21.9424 38.5278 23.1169 38.5278 24.5656C38.5278 26.0144 39.7023 27.1889 41.1511 27.1889Z",
    fill: "#C5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M27.3489 38.8207C28.4836 38.8207 29.4035 37.9008 29.4035 36.766C29.4035 35.6312 28.4836 34.7113 27.3489 34.7113C26.2141 34.7113 25.2942 35.6312 25.2942 36.766C25.2942 37.9008 26.2141 38.8207 27.3489 38.8207Z",
    fill: "#C5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M31.4236 27.0717C33.0008 27.0717 34.2793 25.7931 34.2793 24.216C34.2793 22.6388 33.0008 21.3602 31.4236 21.3602C29.8464 21.3602 28.5679 22.6388 28.5679 24.216C28.5679 25.7931 29.8464 27.0717 31.4236 27.0717Z",
    fill: "#C5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M48.548 18.8694C49.4287 18.8694 50.1426 18.1554 50.1426 17.2748C50.1426 16.3941 49.4287 15.6801 48.548 15.6801C47.6673 15.6801 46.9534 16.3941 46.9534 17.2748C46.9534 18.1554 47.6673 18.8694 48.548 18.8694Z",
    fill: "#C5E2F6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M117.715 91.6258L117.5 91.4494C117.558 91.3778 123.362 84.1976 125.198 73.8944C126.892 64.3941 125.461 50.2129 109.023 36.606L109.2 36.3915C116.503 42.4365 121.496 49.1018 124.041 56.2024C126.078 61.8869 126.559 67.8596 125.471 73.9545C123.618 84.3259 117.774 91.5542 117.715 91.6258Z",
    fill: "#9C9CFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M111.358 38.4437C111.358 38.4437 106.123 37.412 104.382 34.2082C102.64 31.0043 107.4 31.4659 111.358 38.4437Z",
    fill: "#0F538D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M115.629 42.7295C115.629 42.7295 116.431 35.601 114.481 33.4419C112.531 31.2827 110.512 35.8428 115.629 42.7295Z",
    fill: "#0F538D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M115.003 41.9966C115.003 41.9966 108.66 38.6462 105.938 39.6732C103.216 40.6999 106.723 44.2444 115.003 41.9966Z",
    fill: "#0F538D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M118.207 45.9879C118.207 45.9879 111.864 42.6374 109.142 43.6644C106.42 44.6915 109.928 48.2357 118.207 45.9879Z",
    fill: "#0F538D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M121.295 50.3914C121.295 50.3914 114.952 47.041 112.23 48.068C109.508 49.095 113.015 52.6392 121.295 50.3914Z",
    fill: "#0F538D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M123.85 55.8626C123.85 55.8626 117.796 52.0152 115 52.8206C112.204 53.626 115.416 57.4402 123.85 55.8626Z",
    fill: "#0F538D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M125.59 62.5348C125.59 62.5348 120.488 57.4917 117.585 57.6864C114.683 57.881 117.014 62.2892 125.59 62.5348Z",
    fill: "#0F538D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M125.898 70.0544C125.898 70.0544 122.679 63.6439 119.866 62.8993C117.054 62.1547 117.852 67.0772 125.898 70.0544Z",
    fill: "#0F538D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M124.309 78.1448C124.309 78.1448 123.415 71.0272 121.012 69.3864C118.61 67.7452 117.718 72.6513 124.309 78.1448Z",
    fill: "#0F538D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M121.309 85.5749C121.309 85.5749 122.077 78.4427 120.116 76.2932C118.156 74.1433 116.159 78.713 121.309 85.5749Z",
    fill: "#0F538D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M119.206 47.2406C119.206 47.2406 121.934 41.7018 120.819 37.8157C119.705 33.9295 117.685 37.2031 117.824 39.5014C117.963 41.8001 119.206 47.2406 119.206 47.2406Z",
    fill: "#0F538D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M121.618 51.1243C121.618 51.1243 125.187 46.0865 124.701 42.0732C124.215 38.0596 121.703 40.9727 121.477 43.2642C121.251 45.5557 121.618 51.1243 121.618 51.1243Z",
    fill: "#0F538D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M123.623 55.402C123.623 55.402 128.263 51.3289 128.721 47.3122C129.178 43.2955 126.06 45.5468 125.309 47.7236C124.558 49.9001 123.623 55.402 123.623 55.402Z",
    fill: "#0F538D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M125.225 60.5557C125.225 60.5557 129.865 56.4826 130.323 52.466C130.78 48.4493 127.662 50.7005 126.911 52.8773C126.16 55.0538 125.225 60.5557 125.225 60.5557Z",
    fill: "#0F538D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M125.898 67.0611C125.898 67.0611 131.025 63.6201 131.996 59.6958C132.968 55.7715 129.585 57.602 128.56 59.6638C127.534 61.7257 125.898 67.0611 125.898 67.0611Z",
    fill: "#0F538D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M125.053 75.0758C125.053 75.0758 130.739 72.6705 132.438 69.002C134.137 65.3334 130.468 66.4885 129.07 68.3181C127.672 70.1477 125.053 75.0758 125.053 75.0758Z",
    fill: "#0F538D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M122.952 81.8788C122.952 81.8788 129.006 80.6648 131.407 77.4126C133.809 74.1604 129.982 74.5547 128.245 76.0663C126.508 77.5778 122.952 81.8788 122.952 81.8788Z",
    fill: "#0F538D"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M117.55 106.016C117.55 106.016 124.725 100.438 127.922 102.097C131.118 103.757 133.364 99.5339 135.776 99.5091C138.188 99.4843 140.398 101.7 136.841 104.239C133.284 106.779 133.276 107.151 134.11 110.132C134.943 113.113 128.991 114.934 126.108 115.359C123.226 115.784 128.493 117.163 125.894 119.039C123.295 120.916 115.851 118.8 111.196 115.47C106.541 112.139 113.528 103.652 115.875 103.25C118.221 102.849 115.817 105.504 117.55 106.016Z",
    fill: "#5454AF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M123.818 117.709C126.078 114.749 121.271 114.435 121.828 113.321C123.123 110.214 131.022 107.07 128.799 102.417C128.514 102.357 128.222 102.253 127.922 102.097C124.725 100.437 117.55 106.016 117.55 106.016C115.817 105.504 118.221 102.849 115.874 103.25C113.527 103.652 106.541 112.139 111.196 115.47C114.068 117.525 118.001 119.116 121.203 119.593C122.42 119.265 123.27 118.586 123.818 117.709Z",
    fill: "#5454AF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M109.902 114.236C109.837 114.209 109.788 114.15 109.778 114.076C109.761 113.963 109.839 113.857 109.952 113.841C110.07 113.823 121.904 111.987 136.239 101.227C136.33 101.158 136.461 101.177 136.529 101.268C136.598 101.36 136.579 101.49 136.488 101.558C122.062 112.386 110.131 114.233 110.013 114.25C109.974 114.256 109.936 114.25 109.902 114.236Z",
    fill: "#5454AF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M131.993 104.437L133.184 101.104C133.223 100.997 133.341 100.94 133.449 100.979C133.555 101.018 133.613 101.136 133.574 101.244L132.544 104.127L134.946 104.621C135.059 104.645 135.13 104.754 135.107 104.866C135.084 104.978 134.974 105.05 134.862 105.027L131.993 104.437Z",
    fill: "#5454AF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M132.614 111.355C132.608 111.352 132.603 111.35 132.597 111.346L126.203 107.896L127.535 102.922C127.565 102.812 127.678 102.746 127.789 102.776C127.9 102.805 127.965 102.919 127.935 103.03L126.688 107.687L132.794 110.982C132.894 111.037 132.932 111.162 132.878 111.263C132.826 111.357 132.712 111.396 132.614 111.355Z",
    fill: "#5454AF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M126.539 114.699C126.536 114.698 126.533 114.697 126.531 114.696L119.254 111.214L121.632 104.447C121.67 104.339 121.788 104.282 121.896 104.32C122.007 104.362 122.061 104.477 122.023 104.584L119.768 111.001L126.709 114.322C126.812 114.371 126.856 114.495 126.807 114.598C126.759 114.698 126.641 114.742 126.539 114.699Z",
    fill: "#5454AF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M123.53 118.335C123.527 118.334 123.524 118.333 123.522 118.331L113.073 113.381L115.378 105.216C115.409 105.106 115.524 105.042 115.634 105.073C115.743 105.105 115.808 105.219 115.777 105.329L113.566 113.157L123.699 117.957C123.802 118.006 123.847 118.13 123.798 118.233C123.75 118.334 123.631 118.378 123.53 118.335Z",
    fill: "#5454AF"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M103.751 105.066C103.751 105.066 109.694 94.3869 114.523 94.7583C119.352 95.1297 119.91 88.722 122.881 87.4219C125.853 86.1217 129.753 87.7005 126.689 92.7151C123.624 97.73 123.81 98.194 126.41 101.444C129.01 104.695 122.603 110.081 119.259 112.124C115.916 114.167 123.16 113.102 120.931 116.792C118.702 120.482 108.377 121.782 100.863 120.11C93.3497 118.439 97.5285 104.258 100.222 102.526C102.915 100.795 101.336 105.345 103.751 105.066Z",
    fill: "#6F6AE5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M109.233 110.752C117.312 109.916 124.892 103.291 122.106 93.819C121.854 92.3056 122.969 89.6514 123.183 87.3016C123.081 87.3388 122.98 87.3785 122.881 87.4222C119.909 88.7223 119.352 95.13 114.523 94.7586C109.694 94.3873 103.75 105.067 103.75 105.067C101.336 105.345 102.915 100.795 100.222 102.527C97.5287 104.258 93.3496 118.439 100.863 120.111C103.231 120.638 105.879 120.869 108.464 120.823C109.631 119.589 109.276 112.515 109.233 110.752Z",
    fill: "#6F6AE5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M98.6125 119.265C98.5186 119.265 98.4268 119.218 98.3744 119.131C98.2941 119 98.3357 118.829 98.4671 118.749C98.6038 118.665 112.281 110.164 124.358 89.3042C124.435 89.1709 124.605 89.125 124.738 89.2028C124.872 89.2797 124.917 89.4505 124.84 89.5835C112.686 110.575 98.8949 119.14 98.7569 119.224C98.712 119.252 98.6621 119.265 98.6125 119.265Z",
    fill: "#9994FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M120.793 95.5104L120.513 90.7599C120.504 90.6065 120.621 90.4744 120.775 90.4654C120.927 90.4577 121.061 90.5736 121.07 90.7271L121.312 94.8371L124.544 94.1848C124.696 94.1541 124.842 94.2521 124.872 94.4027C124.902 94.5537 124.805 94.7007 124.654 94.731L120.793 95.5104Z",
    fill: "#9994FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M125.203 103.745C125.194 103.745 125.186 103.745 125.177 103.744L115.448 102.839L114.48 95.9831C114.458 95.8309 114.564 95.6899 114.716 95.6685C114.869 95.6458 115.01 95.7531 115.031 95.9053L115.938 102.325L125.228 103.189C125.382 103.203 125.494 103.339 125.48 103.492C125.467 103.637 125.345 103.745 125.203 103.745Z",
    fill: "#9994FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M119.445 111.081C119.441 111.081 119.437 111.081 119.433 111.081L108.595 110.603L107.976 100.977C107.966 100.823 108.083 100.691 108.237 100.681C108.396 100.675 108.522 100.788 108.533 100.941L109.119 110.068L119.457 110.525C119.611 110.531 119.73 110.661 119.723 110.815C119.717 110.965 119.594 111.081 119.445 111.081Z",
    fill: "#9994FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M117.634 117.164C117.631 117.164 117.627 117.164 117.623 117.164L102.086 116.537L100.642 105.22C100.623 105.067 100.73 104.927 100.883 104.908C101.036 104.89 101.176 104.996 101.195 105.149L102.58 116L117.646 116.607C117.799 116.613 117.919 116.743 117.913 116.897C117.907 117.046 117.783 117.164 117.634 117.164Z",
    fill: "#9994FF"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M102.02 92.1181C102.02 92.1181 103.378 79.9716 107.975 78.4492C112.573 76.9268 110.612 70.8009 112.851 68.4542C115.09 66.1072 119.298 66.057 118.408 71.8664C117.518 77.6758 117.868 78.0323 121.522 80.0259C125.176 82.0198 121.346 89.4629 119.051 92.6385C116.757 95.8142 123.027 92.034 122.396 96.2984C121.765 100.563 112.743 105.75 105.167 107.11C97.5912 108.47 95.9686 93.7759 97.784 91.1381C99.5994 88.5007 99.9007 93.3078 102.02 92.1181Z",
    fill: "#9C9CFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M109.359 77.7192C108.979 78.0183 108.525 78.2676 107.975 78.4495C103.378 79.9719 102.02 92.1184 102.02 92.1184C99.9009 93.3078 99.5996 88.501 97.7842 91.1385C95.9689 93.7759 97.5914 108.471 105.168 107.111C105.574 107.037 105.986 106.951 106.4 106.857C109.92 97.5992 110.906 87.6088 109.359 77.7192Z",
    fill: "#8585FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M102.765 107.199C102.678 107.236 102.575 107.227 102.494 107.168C102.369 107.078 102.341 106.904 102.431 106.779C102.525 106.649 111.857 93.5248 114.941 69.6195C114.96 69.4667 115.1 69.3585 115.252 69.3789C115.405 69.3985 115.513 69.5383 115.493 69.6908C112.391 93.7477 102.977 106.975 102.882 107.106C102.852 107.149 102.81 107.18 102.765 107.199Z",
    fill: "#AEAEFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M114.05 76.7213L111.957 72.4476C111.889 72.3097 111.946 72.1426 112.085 72.075C112.222 72.0093 112.39 72.0648 112.457 72.2027L114.268 75.9001L116.998 74.0503C117.127 73.9629 117.298 73.9973 117.385 74.1244C117.471 74.2518 117.438 74.4251 117.311 74.5116L114.05 76.7213Z",
    fill: "#AEAEFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M121.298 82.6135C121.29 82.6169 121.281 82.62 121.273 82.6224L111.95 85.5454L108.408 79.5956C108.33 79.4632 108.373 79.2924 108.505 79.2137C108.638 79.1337 108.809 79.1783 108.887 79.3107L112.204 84.8817L121.107 82.0905C121.254 82.0446 121.41 82.1264 121.456 82.2731C121.499 82.412 121.429 82.5586 121.298 82.6135Z",
    fill: "#AEAEFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M118.82 91.6047C118.816 91.6062 118.812 91.6078 118.808 91.6093L108.627 95.3541L104.339 86.7138C104.27 86.5759 104.327 86.4088 104.464 86.3403C104.609 86.273 104.769 86.3282 104.838 86.4658L108.904 94.6585L118.616 91.0864C118.761 91.0334 118.921 91.1071 118.974 91.2516C119.026 91.392 118.957 91.5473 118.82 91.6047Z",
    fill: "#AEAEFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M119.499 97.9147C119.496 97.9163 119.492 97.9175 119.488 97.9188L104.915 103.342L99.2119 93.4604C99.135 93.3271 99.1806 93.1566 99.3139 93.0797C99.4481 93.0043 99.618 93.0487 99.6946 93.1817L105.162 102.656L119.294 97.397C119.438 97.3434 119.599 97.4166 119.652 97.5607C119.705 97.7012 119.636 97.8574 119.499 97.9147Z",
    fill: "#AEAEFF"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M100.829 124.498H55.9005C52.7205 124.498 50.1428 121.921 50.1428 118.741V23.4124C50.1428 20.2325 52.7205 17.6548 55.9005 17.6548H100.829C104.009 17.6548 106.586 20.2325 106.586 23.4124V118.741C106.586 121.921 104.008 124.498 100.829 124.498Z",
    fill: "#0F538D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M100.586 122.5H56.1431C53.7232 122.5 51.7612 120.538 51.7612 118.118V23.7079C51.7612 21.288 53.7229 19.326 56.1431 19.326H100.586C103.005 19.326 104.967 21.2877 104.967 23.7079V118.118C104.967 120.538 103.005 122.5 100.586 122.5Z",
    fill: "#0F538D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M82.1255 120.125H72.8621C71.7895 120.125 70.9119 119.247 70.9119 118.174C70.9119 117.102 71.7895 116.224 72.8621 116.224H82.1255C83.1981 116.224 84.0757 117.102 84.0757 118.174C84.0757 119.247 83.1981 120.125 82.1255 120.125Z",
    fill: "#0F538D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M57.6072 24.2888C58.4158 24.2888 59.0713 23.6333 59.0713 22.8247C59.0713 22.0161 58.4158 21.3606 57.6072 21.3606C56.7986 21.3606 56.1431 22.0161 56.1431 22.8247C56.1431 23.6333 56.7986 24.2888 57.6072 24.2888Z",
    fill: "#0F538D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M61.5309 23.7069C62.0182 23.7069 62.4132 23.3119 62.4132 22.8247C62.4132 22.3374 62.0182 21.9424 61.5309 21.9424C61.0437 21.9424 60.6487 22.3374 60.6487 22.8247C60.6487 23.3119 61.0437 23.7069 61.5309 23.7069Z",
    fill: "#0F538D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M102.602 26.7251H53.7549V113.995H102.602V26.7251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M97.4019 40.1906H58.9982C57.8187 40.1906 56.8623 39.2342 56.8623 38.0547V31.3683C56.8623 30.1887 57.8187 29.2324 58.9982 29.2324H97.4019C98.5815 29.2324 99.5378 30.1887 99.5378 31.3683V38.0547C99.5378 39.2342 98.5815 40.1906 97.4019 40.1906Z",
    fill: "#E6E8FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M65.6037 43.4611H56.8623V52.2025H65.6037V43.4611Z",
    fill: "#E6E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M76.915 43.4611H68.1736V52.2025H76.915V43.4611Z",
    fill: "#E6E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M88.2265 43.4611H79.4851V52.2025H88.2265V43.4611Z",
    fill: "#E6E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M99.5378 43.4611H90.7964V52.2025H99.5378V43.4611Z",
    fill: "#E6E8FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M65.6037 54.6394H56.8623V63.3807H65.6037V54.6394Z",
    fill: "#E6E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M76.915 54.6394H68.1736V63.3807H76.915V54.6394Z",
    fill: "#E6E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M88.2265 54.6394H79.4851V63.3807H88.2265V54.6394Z",
    fill: "#E6E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M99.5378 54.6394H90.7964V63.3807H99.5378V54.6394Z",
    fill: "#E6E8FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M65.6037 65.8177H56.8623V74.559H65.6037V65.8177Z",
    fill: "#E6E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M76.915 65.8177H68.1736V74.559H76.915V65.8177Z",
    fill: "#E6E8FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M88.2265 65.8177H79.4851V74.559H88.2265V65.8177Z",
    fill: "#FFC608"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M99.5378 65.8177H90.7964V74.559H99.5378V65.8177Z",
    fill: "#E6E8FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M65.6037 76.9959H56.8623V85.7373H65.6037V76.9959Z",
    fill: "#E6E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M76.915 76.9959H68.1736V85.7373H76.915V76.9959Z",
    fill: "#E6E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M88.2265 76.9959H79.4851V85.7373H88.2265V76.9959Z",
    fill: "#E6E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M99.5378 76.9959H90.7964V85.7373H99.5378V76.9959Z",
    fill: "#E6E8FF"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M92.9214 97.641C92.7673 97.641 92.6427 97.7656 92.6427 97.9197V104.186C92.6427 104.871 92.085 105.429 91.3996 105.429H90.4116C90.0827 105.429 89.7724 105.301 89.5381 105.07L75.5223 91.2318C75.1832 90.8973 74.734 90.7125 74.2572 90.7125H61.0053C60.4145 90.7125 59.8794 90.9887 59.5375 91.4702C59.1953 91.9519 59.1106 92.5477 59.3053 93.1054L59.9151 94.8532C60.1671 95.5755 60.85 96.0606 61.6148 96.0606H71.2217C71.554 96.0606 71.8662 96.1899 72.1009 96.4246L75.5695 99.8935C76.0025 100.326 75.9926 100.877 75.8389 101.248C75.6851 101.619 75.3029 102.016 74.6903 102.016H66.7918C65.7992 102.016 64.9913 102.823 64.9913 103.816V105.648C64.9913 106.641 65.7989 107.448 66.7918 107.448H75.5189C76.2043 107.448 76.762 108.006 76.762 108.712C76.762 109.398 76.2043 109.955 75.5189 109.955H58.0613V110.513H75.5189C76.5115 110.513 77.3194 109.705 77.3194 108.691C77.3194 107.698 76.5119 106.891 75.5189 106.891H66.7918C66.1064 106.891 65.5487 106.333 65.5487 105.648V103.816C65.5487 103.13 66.1064 102.572 66.7918 102.572H74.6903C75.4324 102.572 76.0698 102.147 76.3534 101.461C76.6374 100.775 76.488 100.024 75.9632 99.4992L72.4946 96.0303C72.1548 95.6902 71.7028 95.5029 71.2217 95.5029H61.6148C61.0869 95.5029 60.6151 95.1681 60.4411 94.6694L59.8314 92.9216C59.6968 92.5362 59.7554 92.1249 59.9916 91.7922C60.2279 91.4599 60.5974 91.269 61.0053 91.269H74.2572C74.5864 91.269 74.8964 91.3964 75.1308 91.6276L89.1468 105.466C89.486 105.801 89.9352 105.985 90.4116 105.985H91.3996C92.3925 105.985 93.1998 105.178 93.1998 104.185V97.9191C93.1998 97.7656 93.0752 97.641 92.9214 97.641Z",
    fill: "#E6E8FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M96.6822 91.6382C96.6822 93.7155 92.9213 99.2301 92.9213 99.2301C92.9213 99.2301 89.1604 93.7155 89.1604 91.6382C89.1604 89.5609 90.8443 87.8773 92.9213 87.8773C94.9983 87.8773 96.6822 89.5609 96.6822 91.6382Z",
    fill: "#B9BDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M92.9213 93.4839C94.0369 93.4839 94.9413 92.5796 94.9413 91.464C94.9413 90.3484 94.0369 89.444 92.9213 89.444C91.8057 89.444 90.9014 90.3484 90.9014 91.464C90.9014 92.5796 91.8057 93.4839 92.9213 93.4839Z",
    fill: "#0F538D"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M59.1877 112.394C60.3802 112.394 61.3469 111.427 61.3469 110.234C61.3469 109.042 60.3802 108.075 59.1877 108.075C57.9952 108.075 57.0286 109.042 57.0286 110.234C57.0286 111.427 57.9952 112.394 59.1877 112.394Z",
    fill: "#B9BDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M59.1877 111.349C59.8032 111.349 60.3021 110.85 60.3021 110.234C60.3021 109.619 59.8032 109.12 59.1877 109.12C58.5722 109.12 58.0732 109.619 58.0732 110.234C58.0732 110.85 58.5722 111.349 59.1877 111.349Z",
    fill: "#0F538D"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M35.9938 63.9958C35.9938 63.9958 36.8915 70.6267 36.8469 72.3977C36.8022 74.1687 35.5982 80.0119 35.1521 81.8161C34.706 83.6206 34.0817 85.1241 34.7953 86.5852C35.5089 88.0459 35.375 89.5066 35.4643 90.3229C35.5536 91.1391 35.6723 91.3827 35.4792 91.4398C35.286 91.4971 34.5268 90.8669 34.4717 90.3728C34.4165 89.8786 34.3421 89.227 34.2677 89.041C34.1933 88.855 33.5764 89.5494 33.6657 90.1365C33.7549 90.7237 33.8588 90.9816 33.8588 90.9816L33.6567 91.8267C33.6567 91.8267 32.0006 90.7525 31.8221 89.5782C31.6435 88.4039 31.6438 87.5161 32.0747 86.1555C32.5056 84.7949 32.0599 74.9279 32.7735 72.5791C33.4871 70.2305 31.9411 63.0986 31.9411 63.0986L35.9938 63.9958Z",
    fill: "#FFAE83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M36.0924 64.7444C36.0322 64.281 35.9935 63.9958 35.9935 63.9958L31.9412 63.0986C31.9412 63.0986 33.4871 70.2305 32.7735 72.5791C32.2567 74.28 32.2146 82.3397 32.1405 85.8402C34.5318 75.99 33.0073 71.6956 34.9032 66.0071C35.0861 65.6419 35.5093 65.0392 36.0924 64.7444Z",
    fill: "#F9A37D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M32.2236 86.7427C32.2236 86.7427 33.175 86.4277 33.5467 86.9717C33.9184 87.5158 33.1304 88.5326 33.0414 88.9623C32.9521 89.3919 32.9968 89.9791 33.0414 90.0792C33.086 90.1793 33.0116 90.3656 33.0116 90.3656C33.0116 90.3656 33.4565 90.7057 33.6459 90.8095C33.8353 90.9134 34.4389 90.967 34.632 91.3536C34.1416 91.7117 33.3229 91.3111 32.7956 91.132C32.2686 90.9528 31.806 90.5662 31.7103 90.0649C31.6145 89.5637 31.5841 87.7688 31.7927 87.2985C32.0007 86.8288 32.068 86.7839 32.2236 86.7427Z",
    fill: "#FFB797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M31.8518 90.237C31.8518 90.237 31.956 91.397 32.8478 91.8267C33.7397 92.2563 35.1967 92.3137 35.5978 92.0988C35.6871 91.7408 34.5039 91.5142 34.156 91.3542C33.8079 91.1943 32.3723 90.2801 32.3723 90.2373C32.3723 90.1942 31.8518 90.237 31.8518 90.237Z",
    fill: "#FFB797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M32.417 91.3111C32.417 91.3111 32.4688 91.8409 33.134 92.2204C33.7993 92.6001 34.8102 93.044 34.9888 93.0583C35.167 93.0725 35.0929 92.2848 34.4686 92.0272C33.8442 91.7696 32.417 91.3111 32.417 91.3111Z",
    fill: "#FFB797"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M31.6737 53.2441C31.6737 53.2441 30.6926 57.4458 30.3953 63.9958C32.1198 64.8173 36.8467 64.3876 36.8467 64.3876C36.7276 63.5571 36.5791 63.3277 36.7276 62.9843C36.8764 62.6405 36.5494 60.3452 35.1519 58.8721C33.7547 57.399 32.5953 53.6719 31.6737 53.2441Z",
    fill: "#FFA726"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M39.9389 103.885C40.058 105.833 39.7011 111.847 41.3066 118.149C42.9121 124.45 43.5067 127.715 43.5067 128.574C44.9932 128.976 46.1231 128.345 46.1231 128.345C46.1231 128.345 45.9449 120.497 46.1231 116.087C46.3014 111.676 46.1231 98.7294 45.7068 95.808C45.5025 94.3742 45.4278 92.4299 45.4603 90.5439L37.0674 91.494C38.2159 96.8868 39.8527 102.478 39.9389 103.885Z",
    fill: "#FFAE83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M42.4255 101.946C42.6716 100.469 44.4399 99.864 46.0016 100.319C45.9245 98.288 45.8253 96.6403 45.7065 95.8077C45.5022 94.3739 45.4275 92.4296 45.4601 90.5436L37.0671 91.4937C38.2163 96.8868 39.8531 102.478 39.939 103.885C40.058 105.832 39.7012 111.847 41.3067 118.148C42.9122 124.45 43.5068 127.715 43.5068 128.574C43.9358 128.69 44.3335 128.718 44.6848 128.702C43.8202 119.748 41.2084 110.954 42.4255 101.946Z",
    fill: "#F9A37D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M54.5962 73.7822C53.1692 71.3763 38.9877 72.837 38.9877 72.837C38.9877 72.837 35.4199 79.2527 36.074 85.6115C36.2556 87.3769 36.6255 89.4207 37.0672 91.494L45.4602 90.5439C45.494 88.5872 45.6428 86.6927 45.8852 85.4971C46.8961 87.7886 47.3121 96.1518 46.8961 102.568C46.4797 108.984 47.9296 120.67 47.056 125.596C46.4202 128.976 46.8961 129.434 49.0366 129.463C51.2367 129.291 50.2258 127.315 49.988 125.51C49.7503 123.706 52.2774 118.207 53.1692 112.879C54.0611 107.551 53.9783 103.599 54.0199 100.506C54.0611 97.4122 56.0234 91.7414 56.202 87.1013C56.3805 82.4612 56.0231 76.1881 54.5962 73.7822Z",
    fill: "#FFAE83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M56.2017 87.1007C56.3799 82.4606 56.0234 76.1881 54.5962 73.7822C53.1692 71.3763 38.9877 72.837 38.9877 72.837C38.9877 72.837 35.4199 79.2527 36.074 85.6115C36.2556 87.3769 36.6255 89.4207 37.0672 91.494L45.4602 90.5439C45.4939 88.5872 45.6428 86.6927 45.8852 85.4971C46.8961 87.7886 47.3121 96.1518 46.8961 102.568C46.4797 108.984 47.9296 120.67 47.056 125.596C46.4875 128.619 46.8093 129.304 48.4154 129.436C47.5003 125.598 51.1301 121.651 49.948 118.105C47.4407 112.255 48.8336 106.126 49.948 100.554C50.1629 98.8345 52.2008 99.9332 54.0168 100.781C54.0177 100.689 54.0186 100.596 54.0199 100.506C54.0611 97.4119 56.0231 91.7408 56.2017 87.1007Z",
    fill: "#F9A37D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M37.1787 76.5939C37.1787 76.5939 33.9423 79.1942 35.0729 87.0412C36.2035 94.8882 37.5501 98.2319 37.5501 98.2319C37.5501 98.2319 46.0646 99.9645 55.1104 97.1245C56.2441 90.5237 58.9094 79.4725 54.0338 72.9256C46.5116 73.39 37.1787 76.5939 37.1787 76.5939Z",
    fill: "#0F538D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M41.8684 81.6084C45.8253 78.3934 51.9744 78.9065 55.2555 74.971C54.9142 74.2518 54.5112 73.5664 54.0338 72.9253C46.5116 73.3897 37.1787 76.5936 37.1787 76.5936C37.1787 76.5936 33.9423 79.1938 35.0729 87.0409C36.2035 94.8879 37.5501 98.2316 37.5501 98.2316C37.5501 98.2316 37.932 98.3088 38.6134 98.4036C36.0875 92.704 37.2054 85.4605 41.8684 81.6084Z",
    fill: "#1F4D75"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M46.2788 127.722C46.2788 127.722 43.8261 127.357 43.3577 128.238C42.8893 129.119 42.6273 131.267 42.7761 131.783C43.46 132.47 46.1796 132.1 47.2519 131.75C48.3245 131.399 46.2788 127.722 46.2788 127.722Z",
    fill: "#0F538D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M47.373 130.183C47.4155 130.58 47.3433 130.879 47.0736 130.967C46.0645 131.296 43.5969 131.643 42.7394 131.11C42.7267 131.409 42.7376 131.65 42.776 131.783C43.4599 132.47 46.1795 132.1 47.2518 131.75C47.6805 131.61 47.6108 130.938 47.373 130.183Z",
    fill: "#0F538D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M46.7305 127.572C46.8344 127.519 48.663 126.426 50.3808 127.572C50.8203 128.603 50.6418 130.179 50.9986 131.21C51.3554 132.241 52.8112 135.287 51.9785 136.633C50.4028 137.349 46.8895 137.31 46.8895 137.31C46.8895 137.31 45.8473 135.392 46.1189 133.673C46.3904 131.954 46.45 132.413 46.3309 130.723C46.2119 129.033 46.1914 127.845 46.7305 127.572Z",
    fill: "#0F538D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M46.8366 130.88C46.8366 130.88 48.0406 133.114 47.8177 134.188C47.5948 135.262 46.4798 136.035 46.8366 137.195C47.1934 138.355 51.4745 136.981 51.8759 136.723C52.2774 136.465 52.0099 135.936 51.1177 134.267C50.2258 132.598 50.3594 131.911 50.4041 130.88C50.4487 129.849 49.6458 129.29 48.739 129.147C47.8323 129.004 46.3161 129.548 46.8366 130.88Z",
    fill: "#0F538D"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M31.6736 53.2441C31.6736 53.2441 40.7116 45.5697 52.6634 46.6581C52.9607 47.9756 53.793 52.8448 52.6634 56.9693C51.5337 61.0939 52.5645 64.9317 53.2384 65.9057C53.9121 66.8794 55.3988 72.9517 55.8744 75.1285C50.7011 78.9093 38.2921 77.9356 35.9937 77.4197C38.5119 70.8893 39.7606 67.9105 38.9874 66.8794C38.2143 65.8483 37.5605 65.791 37.5605 64.989C37.5605 64.1871 37.0849 63.4998 36.7281 62.9839C36.3713 62.4684 36.5499 62.1045 36.3118 61.3413C36.0737 60.578 34.409 59.1458 33.6954 57.943C32.9818 56.7402 31.6736 53.2441 31.6736 53.2441Z",
    fill: "#FFC608"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M43.2611 71.3006C47.4725 63.6675 53.9196 55.0399 48.9806 46.5924C38.9044 47.1113 31.6733 53.2444 31.6733 53.2444C31.6733 53.2444 32.9815 56.7405 33.6952 57.9433C34.4088 59.1465 36.0735 60.5783 36.3116 61.3416C36.5493 62.1048 36.3711 62.4687 36.7279 62.9843C37.0847 63.4998 37.5602 64.1874 37.5602 64.9893C37.5602 65.7913 38.2143 65.8487 38.9872 66.8797C39.7603 67.9108 38.5116 70.8896 35.9935 77.42C36.9319 77.6305 39.556 77.917 42.6845 77.9256C42.1684 75.596 42.2828 73.2573 43.2611 71.3006Z",
    fill: "#FFA726"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M55.2637 49.0715C55.2637 49.0715 57.2855 48.4986 57.8801 48.1836C58.4746 47.8687 60.1694 43.3144 60.2584 41.9396C60.3477 40.5647 59.5745 40.0207 59.5745 38.8461C59.5745 37.6715 61.3285 33.3182 61.8639 33.2323C62.3989 33.1464 62.176 34.1167 61.8639 34.8793C61.5517 35.6419 61.2842 36.6194 61.3735 36.8128C61.4627 37.0063 61.7916 36.8451 62.0201 36.7858C62.2486 36.7266 62.4439 36.8451 62.4606 37.3767C62.4718 37.5218 63.0124 37.2853 63.0961 37.8653C63.1631 38.0156 63.6144 37.9189 63.6535 38.4344C63.6926 38.95 63.425 39.777 62.6221 40.2067C62.4662 40.615 63.2465 44.4171 62.5998 47.2096C61.9532 50.0021 61.8862 50.0452 61.3735 50.4534C60.8607 50.8617 58.8761 52.3007 56.2895 53.16C53.7028 54.0194 55.2637 49.0715 55.2637 49.0715Z",
    fill: "#FFAE83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M60.778 40.5505C60.3955 39.5944 59.8821 38.901 59.6874 38.1095C59.6158 38.4118 59.5743 38.6666 59.5743 38.8464C59.5743 40.0207 60.3474 40.5651 60.2582 41.9399C60.1689 43.3148 58.4744 47.8687 57.8798 48.1839C57.2853 48.4989 55.2634 49.0718 55.2634 49.0718C55.2634 49.0718 54.8796 50.2901 54.8083 51.4126C59.5706 50.7064 62.0016 45.1996 60.778 40.5505Z",
    fill: "#F9A37D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M52.6634 46.6581C52.6634 46.6581 53.5255 46.8444 53.8377 47.8324C54.1498 48.8207 56.2436 48.1768 56.3552 48.1768C57.5815 49.4872 57.5614 50.2597 57.606 51.9997C57.6507 53.7397 56.4689 54.6849 56.2904 54.8139C55.4655 54.9212 53.2505 55.6661 52.6634 56.9693C52.1432 54.9215 52.4256 46.7942 52.6634 46.6581Z",
    fill: "#FFC608"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M50.3445 46.5524C50.9375 46.5598 51.8905 46.6581 51.8905 46.6581C51.8905 46.6581 49.9877 46.3717 49.3336 45.2259C48.6795 44.0801 48.3822 42.9917 48.8581 41.1014C49.3339 39.211 48.2706 36.2235 47.3716 35.2011C46.2739 33.9528 43.6097 33.3762 42.4953 34.4559C42.4953 34.4559 40.2363 33.4254 38.6308 35.8887C37.0253 38.352 37.2039 45.2259 36.4308 46.6581C35.6576 48.0903 32.9746 51.8174 33.9334 55.1933C34.3947 56.8171 35.2363 57.8262 35.9937 58.666C34.9964 56.2098 35.36 53.3529 35.4766 52.6256C35.5184 53.7137 35.6675 55.7017 36.1921 57.3705C36.9581 59.8083 35.9041 60.3985 37.4457 63.639C36.7842 61.1664 37.0625 60.1391 37.2368 59.0944C37.3136 58.6328 37.438 58.1135 37.5201 57.5472C37.7396 59.2646 37.5595 60.5604 37.5266 61.0288C37.5434 61.1301 37.5573 61.2331 37.5604 61.3413C37.6199 63.3848 37.8577 66.0201 42.0201 67.9675C40.9496 65.9624 40.9496 62.7917 43.1497 61.3413C45.3498 59.8905 45.8848 55.938 45.6471 54.9069C46.8958 56.4535 46.3607 59.3749 45.2307 60.6927C44.1011 62.0102 43.0902 64.1871 43.774 66.3639C44.2201 63.0986 45.3498 62.9843 47.0743 60.9792C48.7985 58.9741 50.404 54.9221 49.1553 51.1051C50.3445 52.1002 51.0581 57.1984 48.739 60.8071C51.5337 57.5992 51.2494 50.7523 50.2651 48.6629C49.2806 46.5738 49.7518 46.545 50.3445 46.5524Z",
    fill: "#101431"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M50.3444 46.5524C50.9375 46.5598 51.8904 46.6581 51.8904 46.6581C51.8904 46.6581 49.9876 46.3717 49.3335 45.2259C48.6794 44.0801 48.3821 42.9917 48.858 41.1014C49.3338 39.211 48.2705 36.2235 47.3715 35.2011C46.692 34.4286 45.4126 33.9143 44.2721 33.8898C43.4041 33.9872 42.6394 34.344 42.1471 35.0824C40.1969 38.7041 42.9829 42.0472 43.8186 45.3905C44.3757 47.3407 44.6544 49.5693 43.5399 51.5195C40.8457 56.4588 38.6986 63.0246 41.9009 67.7211C40.9561 65.7113 41.0367 62.7341 43.1496 61.3406C45.3497 59.8898 45.8848 55.9373 45.647 54.9063C46.8957 56.4529 46.3606 59.3743 45.2307 60.6921C44.101 62.0096 43.0901 64.1864 43.774 66.3633C44.2201 63.098 45.3497 62.9836 47.0742 60.9786C48.7985 58.9735 50.4039 54.9215 49.1553 51.1044C50.3444 52.0995 51.058 57.1978 48.7389 60.8065C51.5336 57.5986 51.2493 50.7517 50.2651 48.6623C49.2805 46.5738 49.7517 46.545 50.3444 46.5524Z",
    fill: "#131938"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M43.5399 51.5201C44.6544 49.5699 44.3757 47.3413 43.8186 45.3911C42.9829 42.0481 40.1969 38.7047 42.1471 35.083C42.6394 34.3446 43.4042 33.9875 44.2722 33.8904C43.57 33.8753 42.9199 34.0448 42.4955 34.4562C42.4955 34.4562 40.2366 33.4258 38.6311 35.889C37.0256 38.3523 37.2042 45.2262 36.431 46.6584C35.6579 48.0906 32.9748 51.8177 33.9337 55.1936C34.3949 56.8174 35.2366 57.8265 35.9939 58.6663C34.9966 56.2101 35.3603 53.3532 35.4768 52.6259C35.5187 53.714 35.6678 55.702 36.1923 57.3708C36.9583 59.8086 35.9043 60.3989 37.446 63.6393C36.7844 61.1667 37.0628 60.1394 37.237 59.0947C37.3139 58.6331 37.4382 58.1138 37.5204 57.5475C37.7398 59.2649 37.5597 60.5607 37.5269 61.0291C37.5436 61.1305 37.5576 61.2334 37.5607 61.3416C37.6202 63.3851 37.8579 66.0204 42.0203 67.9678C41.9778 67.8885 41.9403 67.8044 41.9016 67.7217C38.6987 63.0252 40.846 56.4594 43.5399 51.5201Z",
    fill: "#0D1128"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4795_1352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155,
    height: 155,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingReportCard);
export default __webpack_public_path__ + "static/media/BookingReportCard.90d10d1bf5e0ed32398ac9873d21d242.svg";
export { ForwardRef as ReactComponent };